import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CamelCaseSplitPipe } from './pipes/camel-case-split.pipe';
import { FormatDatePipe } from './pipes/format-date.pipe';
import { NotificationBarComponent } from './notification-bar/notification-bar.component';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { CmsAlertDialogComponent } from './components/cms-alert-dialog/cms-alert-dialog.component';
import { CmsDialogComponent } from './components/cms-dialog/cms-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ProcessingBoundaryComponent } from './standalone/components/processing-boundary/processing-boundary.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { ContentStatusMessageComponent } from './components/content-status-message/content-status-message.component';
import { AutoCompleteComponent } from '../shared-form-sections/components/auto-complete/auto-complete.component';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { CustomDateFormatPipe } from './pipes/custom-date-format.pipe';
import { FormatDateOnlyPipe } from './pipes/format-date-only.pipe';
import { SectionHeaderComponent } from './standalone/components/section-header/section-header.component';
import { ToastrMessageComponent } from './components/toastr-message/toastr-message.component';
import { ContentStatusDescriptionPipe } from './pipes/content-status-description.pipe';

@NgModule({
  declarations: [
    CamelCaseSplitPipe,
    FormatDatePipe,
    NotificationBarComponent,
    CmsDialogComponent,
    CmsAlertDialogComponent,
    ContentStatusMessageComponent,
    CustomDateFormatPipe,
    FormatDateOnlyPipe,
    ToastrMessageComponent,
    ContentStatusDescriptionPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    MatListModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ProcessingBoundaryComponent,
    MatAutocompleteModule,
    MatSelectModule,
    AutoCompleteComponent,
    SectionHeaderComponent,
  ],
  exports: [
    CamelCaseSplitPipe,
    FormatDatePipe,
    NotificationBarComponent,
    CmsDialogComponent,
    CmsAlertDialogComponent,
    SectionHeaderComponent,
    ProcessingBoundaryComponent,
    ContentStatusMessageComponent,
    CustomDateFormatPipe,
    FormatDateOnlyPipe,
    ContentStatusDescriptionPipe,
  ],
})
export class SharedModule {}
